export default __webpack_public_path__ + "static/media/Ntorq125_LateralDer.4d8eb972.webp";